module.exports = __webpack_public_path__ + "img/factory-icon-1.4e69055f.svg";